import React from 'react';
import './Landing.css';

function LandingSection() {
  return (
    <div id="industry-landing">
      <div id="industry-header">
        <h1>
        Partnerships with the market
        </h1>
        <p>
        Innovation strategies applied in market/academy partnerships
        </p>
      </div>
      <div id="industry-image" />
    </div>
  );
}

export default LandingSection;
